import { render, staticRenderFns } from "./icon-component.vue?vue&type=template&id=df23a12a&scoped=true"
import script from "./icon-component.vue?vue&type=script&lang=js"
export * from "./icon-component.vue?vue&type=script&lang=js"
import style0 from "./icon-component.vue?vue&type=style&index=0&id=df23a12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df23a12a",
  null
  
)

export default component.exports